module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_back.6d5d9aa1.jpg";